import { ApiError, fieldErrorsOf } from '@/api/client';
import { notAvailableYet } from '@/lib/mutationError';
import type { SaveFailure } from './generalFailure';
import { hasLimitError, limitFieldsFromDetails } from './limitsModel';

/** A 400/422: the API's messages go under their limit; with none for a limit the problem is shown as it is. */
function invalidInput(err: ApiError): SaveFailure {
  const fields = limitFieldsFromDetails(err.details);
  if (Object.keys(fields).length === 0) Object.assign(fields, fieldErrorsOf(err));
  return hasLimitError(fields) ? { server: fields } : { problem: err };
}

/** Maps a failed limits save onto the form: 501 / 412 / 403 are problems, 400 / 422 are field messages, anything else a toast. */
export function limitsFailure(err: unknown): SaveFailure {
  const unavailable = notAvailableYet(err);
  if (unavailable) return { problem: unavailable };
  if (!(err instanceof ApiError)) return { toast: { title: 'Could not save the limits' } };
  if (err.status === 412) return { problem: new ApiError(412, err.code, 'This project changed since the page loaded. It was reloaded: review the limits and save again.', err.requestId) };
  if (err.status === 422 || err.status === 400) return invalidInput(err);
  if (err.status === 403) return { problem: err };
  return { toast: { title: err.toastTitle, description: `${err.code} · ${err.message}` } };
}
